import type { RouteRecordRaw } from 'vue-router'

export const rolesRoutes: RouteRecordRaw[] = [
  {
    path: '/roles',
    name: 'ROLES',
    component: () => import('./RolesPage.vue'),
    meta: { requiresAuth: true },
  },
]
